var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 5.75C6.41421 5.75 6.75 5.41421 6.75 5C6.75 4.58579 6.41421 4.25 6 4.25C5.58579 4.25 5.25 4.58579 5.25 5C5.25 5.41421 5.58579 5.75 6 5.75Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 1.25C3.93234 1.25 2.25 2.85898 2.25 4.83594C2.25 5.77742 2.67914 7.02945 3.52547 8.55734C4.20516 9.78406 4.99148 10.8934 5.40047 11.4453C5.46958 11.5396 5.55994 11.6163 5.66422 11.6692C5.76851 11.7221 5.88378 11.7496 6.0007 11.7496C6.11762 11.7496 6.2329 11.7221 6.33718 11.6692C6.44147 11.6163 6.53183 11.5396 6.60094 11.4453C7.00922 10.8934 7.79625 9.78406 8.47594 8.55734C9.32086 7.02992 9.75 5.77789 9.75 4.83594C9.75 2.85898 8.06766 1.25 6 1.25ZM6 6.5C5.70333 6.5 5.41332 6.41203 5.16664 6.2472C4.91997 6.08238 4.72771 5.84811 4.61418 5.57403C4.50065 5.29994 4.47094 4.99834 4.52882 4.70736C4.5867 4.41639 4.72956 4.14912 4.93934 3.93934C5.14912 3.72956 5.41639 3.5867 5.70736 3.52882C5.99834 3.47094 6.29994 3.50065 6.57403 3.61418C6.84811 3.72771 7.08238 3.91997 7.2472 4.16664C7.41203 4.41332 7.5 4.70333 7.5 5C7.49957 5.39769 7.34139 5.77897 7.06018 6.06018C6.77897 6.34139 6.39769 6.49957 6 6.5Z",
    fill: "#310048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconLocation);
export default __webpack_public_path__ + "static/media/card_icon_location.abf9cf21483c69af1bfc0796c89ee94c.svg";
export { ForwardRef as ReactComponent };